import React from "react"
import Intervention from './Intervention'

function Interventions({ sinistralite }) {
  return (
    <table>
      <thead>
      <tr>
        <th>Date</th>
        <th>Type Intervention</th>
        <th>Services Aditionnels</th>
      </tr>
      </thead>
      <tbody>
      {sinistralite.map((intervention, index) => <Intervention key={index} intervention={intervention}/>)}
      </tbody>
    </table>
  )
}

export default Interventions